import { QueryClient, QueryCache } from '@tanstack/react-query';
import { handleError } from './query-client.errors';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 0,
      retry: false,
      refetchOnWindowFocus: false,
    },
    mutations: {
      onError: (error) => {
        handleError(error);
      },
    },
  },
  queryCache: new QueryCache({
    onError: (error) => {
      handleError(error);
    },
  }),
});
